module.exports = __webpack_public_path__ + "static/media/icon-plus.322bfbd4.svg";